import { PageHero } from "@/components/site/PageHero";
import { CourseExplorer } from "@/components/site/CourseExplorer";
import { SubjectCombinations } from "@/components/site/SubjectCombinations";
import { Compare } from "@/components/home/Compare";
import { DirectEntry } from "@/components/home/DirectEntry";
import { IMAGES } from "@/data/content";
import { useSEO } from "@/hooks/useSite";

export default function Programmes() {
  useSEO({
    title: "Programmes & Course Areas | IAUE School of Basic Studies",
    description: "Explore JUPEB & IJMB course areas and subject combinations at the School of Basic Studies, IAUE Port Harcourt, and compare the two pathways.",
  });
  return (
    <>
      <PageHero overline="Programmes" title="Programmes & Course Areas"
        subtitle="Discover the course areas foundation studies can prepare you for, and the subject combinations that support them."
        crumb="Programmes" image={IMAGES.library} />
      <CourseExplorer />
      <SubjectCombinations />
      <Compare />
      <DirectEntry />
    </>
  );
}
